module.exports = __webpack_public_path__ + "static/img/mylogo.900992d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mylogo.png
// module id = CUkX
// module chunks = 29